// extracted by mini-css-extract-plugin
export default {"root":"TextResult_root__AvwUh","text":"TextResult_text__t0Sb9","highlight":"TextResult_highlight__-8Mt9"};